import { toast } from 'react-hot-toast';
import { RenderIcon } from 'src/assets/icons';

interface CustomToastProps {
  message: string;
  type: 'error';
}

const Toast: React.FC<CustomToastProps> = ({ message, type }) => {
  return (
    <div
      className={` flex items-center justify-between w-[343px] sm:w-[400px] md:w-[300px] px-4 py-3 rounded-lg border-l-4 z-[99999999] font-popins bg-[#2A2A2A] text-[#ddd] border-[#FA4747]`}
      
    >
      <RenderIcon type="dangerIcon" width={20} height={20} />
      <span className="text-sm z-[99999999] ml-2">{message}</span>
      <button
        onClick={() => toast.dismiss()}
        className="text-[#717171] hover:text-[#717171] z-[99999999]"
      >
        <RenderIcon type="close" width={20} height={20} />
      </button>
    </div>
  );
};

export default Toast;
